import { Link } from "react-router-dom"

import { Analytics } from "utils/analytics"
import { Icon } from "components/Icon"

export function GoToAuth() {
    return (
        <Link
            to="/my/authorization"
            onClick={() => {
                Analytics.lk_login_app()
            }}
        >
            <Icon type="log_in" size={24} className={"icon-link"} />
        </Link>
    )
}
